export const FooterDefaultClassesMock = ['footer'];
export const FooterDefaultPropsMock = {};
